import { render, staticRenderFns } from "./QuestionCreate.vue?vue&type=template&id=2c76470d&scoped=true"
import script from "./QuestionCreate.vue?vue&type=script&lang=js"
export * from "./QuestionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76470d",
  null
  
)

export default component.exports